import { Payload } from "./payload";
export class SlingshotEvent extends Payload{
    constructor(init?: Partial<SlingshotEvent>) {
        super('SlingshotEvent');
        Object.assign(this, init);
    }
    type: string = 'SlingshotEvent';
    connectionId?: string;
    x!: number;
    y!: number;
    velocityX!: number;
    velocityY!: number;
    scale!: number;
    levelName!: string;
}